// extracted by mini-css-extract-plugin
module.exports = {"container":"listDuplicateOIBMember_container__fFTtA"};